import { HttpClient } from '@angular/common/http';
import { Provider } from '@angular/core';
import { AutocompleteHit, AutocompleteResponse, ControlChange, ControlParameters, ControlState } from '../../../../api/model/models';
import { CfContextService } from '../../../../utils';
import { CplaceControlService } from '../cplace-control.service';
import { ControlChangeHandler, MockCplaceControlService, MockSubmitRequestMapping } from '../cplace-control.service.mock';

export function mockCplaceControlServiceProvider<U extends ControlChange, V extends ControlParameters, T>(
  mockControlState: ControlState,
  controlChangeHandler: ControlChangeHandler<U, V, T>,
  mockData?: T,
  mockSearchBuiltinControlAutocompleteHits?: AutocompleteHit[]
): Provider {
  return {
    provide: CplaceControlService,
    useFactory: (httpClient: HttpClient, cfContextService: CfContextService) => {
      const mockRequestMapping = new Map<string, MockSubmitRequestMapping>();
      mockRequestMapping.set(mockControlState.identity.featureName, {
        controlState: mockControlState,
        controlChangeHandler: controlChangeHandler,
        mockData: mockData,
      });

      const mockSearchBuiltinControlAutocompleteMapping = new Map<string, AutocompleteResponse>();
      mockSearchBuiltinControlAutocompleteMapping.set(mockControlState.identity.featureName, {
        hits: mockSearchBuiltinControlAutocompleteHits ?? [],
        totalHitCount: 500,
      });

      return new MockCplaceControlService(
        httpClient,
        cfContextService,
        mockRequestMapping,
        undefined,
        mockSearchBuiltinControlAutocompleteMapping
      );
    },
    deps: [HttpClient, CfContextService],
  };
}
